import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Subject} from 'rxjs';
import {messageData} from '../../datas/message';
import {SnackBarService} from '../ng-material-snackbar/snackbar.service';

@Component({
  selector: 'ngx-file-upload-util',
  templateUrl: './file-upload-util.component.html',
  styleUrls: ['./file-upload-util.component.scss'],
})
export class FileUploadUtilComponent implements OnInit {
  @Input() api;
  @Input() emitUpload: Subject<boolean>;
  @Input() image?;
  @Input() disabled?;
  @Output() removeImageEvent = new EventEmitter();

  @ViewChild('uploadField') uploadField: ElementRef;
  @Input() label;

  @Input() fileFormat?;

  file;

  ngOnInit() {
    this.emitUpload.subscribe((v) => {
      this.upload();
    });
  }

  constructor(
    protected httpClient: HttpClient,
    private snackBarService: SnackBarService,
    private cdr: ChangeDetectorRef
  ) {}

  onFileChange(event: any) {
    if (event.target.files.length > 0) {
      this.file = event.target.files[0];

      // More than 5mb
      if (this.file.size > 5000 * 1024) {
        this.snackBarService.openSnackBar('File Upload Size Exceeded 5mb', 'error');
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);

        this.image = reader.result;
        reader.onload = (_event) => {
          this.image = reader.result;
        };
      }
    }
  }

  upload() {
    const formData = new FormData();
    formData.append('file', this.file);

    if (this.file) {
      this.httpClient.post(this.api, formData).subscribe((res) => {
        this.uploadField.nativeElement.value = '';
        this.file = '';
      });
    }
  }

  removeImage() {
    this.uploadField.nativeElement.value = '';
    this.file = '';
    this.image = null;

    this.removeImageEvent.emit();
  }
}
